module.exports = __webpack_public_path__ + "img/Sammarbete-trollegate.40fb3afe.jpg";